import React from "react";

export interface ServiceHeroImageProps {
  src?: string;
  alt: string;
  className?: string;
}

const FALLBACK_SRC = "/images/services/abstract-agentic-hero.jpg";

export default function ServiceHeroImage({
  src = FALLBACK_SRC,
  alt,
  className = ""
}: ServiceHeroImageProps) {
  return (
    <div
      className={`mb-10 overflow-hidden rounded-2xl border border-border ${className}`}
    >
      <img
        src={src}
        alt={alt}
        loading="lazy"
        width={800}
        height={400}
        className="h-[400px] w-full object-cover"
        decoding="async"
      />
    </div>
  );
}
